import React from "react"
import { KLARNA_OSM_KEYS } from "../../utils/constants"
import { BoxProps, Stack } from "../../vanilla"

interface KlarnaOSMProps extends BoxProps<React.ElementType>  {
    keyId: KLARNA_OSM_KEYS
}

export const KlarnaOSM = ({keyId, ...rest}: KlarnaOSMProps) => { 
    return (
        <Stack {...rest}>
            <klarna-placement data-key={keyId} data-locale="en-GB"></klarna-placement>
        </Stack>
    )
}